export default __webpack_public_path__ + "static/media/1-4-1.b777392d.png";